(function () {
  var MERCHANT = 'their-nibs';
  var API_BASE = 'https://api.feefo.com/api/20/products/ratings';

  function fetchRating(el) {
    var sku = el.getAttribute('data-feefo-product-sku');
    var scoreEl = el.querySelector('.product-rating__score');
    if (!sku || !scoreEl) return;

    el.setAttribute('data-feefo-loading', '1');

    fetch(API_BASE + '?merchant_identifier=' + MERCHANT + '&parent_product_sku=' + sku + '&review_count=true')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data && data.products;
        if (!products || !products.length) return;

        var weightedSum = 0;
        var totalReviews = 0;
        products.forEach(function (p) {
          if (p.rating && p.review_count) {
            weightedSum += p.rating * p.review_count;
            totalReviews += p.review_count;
          }
        });

        if (!totalReviews) return;
        scoreEl.textContent = (weightedSum / totalReviews).toFixed(1);
        el.style.visibility = 'visible';
      })
      .catch(function () {});
  }

  function loadRatings(root) {
    var containers = (root || document).querySelectorAll('[data-feefo-product-sku]:not([data-feefo-loading])');
    containers.forEach(fetchRating);
  }

  function observeNewProducts() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches('[data-feefo-product-sku]') && !node.getAttribute('data-feefo-loading')) {
            fetchRating(node);
          }
          var nested = node.querySelectorAll('[data-feefo-product-sku]:not([data-feefo-loading])');
          nested.forEach(fetchRating);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      loadRatings();
      observeNewProducts();
    });
  } else {
    loadRatings();
    observeNewProducts();
  }
})();
